import {Component, Input, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';
import {NgClass, NgIf} from '@angular/common';
import {interval, Subscription} from 'rxjs';
import {startWith, switchMap} from 'rxjs/operators';
import {TipsportService} from '../../../services/tipsport.service';
import {TipsportOdds} from '../../../model/broadcast/tipsport';

// In-house replacement for the old Tipsport iframe. The iframe polled a single
// globally-saved match, so two concurrent broadcasts could never show different
// matches. Now the banner fetches odds for its own broadcast's matchId straight
// from the Tipsport save endpoint (via the same-origin proxy) on a short timer
// while it is visible — the save response is self-contained per match, so two
// productions requesting different matches never interfere. Markup + styling
// mirror Tipsport's banner.php/300x720.css so it looks identical.
@Component({
  selector: 'app-tipsport-rti',
  templateUrl: './tipsport-rti.component.html',
  styleUrls: ['./tipsport-rti.component.scss'],
  imports: [NgIf, NgClass],
  standalone: true
})
export class TipsportRtiComponent implements OnChanges, OnDestroy {

  @Input() matchId?: string;

  odds?: TipsportOdds;
  private sub?: Subscription;

  constructor(private tipsport: TipsportService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.matchId) {
      this.subscribeToOdds();
    }
  }

  // Refresh interval while the banner is visible. Odds change slowly, so ~2s
  // matches Tipsport's own banner cadence without hammering the endpoint.
  private static readonly REFRESH_MS = 2000;

  private subscribeToOdds(): void {
    this.sub?.unsubscribe();
    this.odds = undefined;
    if (!this.matchId) {
      return;
    }
    const matchId = this.matchId;
    this.sub = interval(TipsportRtiComponent.REFRESH_MS).pipe(
      startWith(0),
      switchMap(() => this.tipsport.getOdds(matchId)),
    ).subscribe({
      next: odds => this.odds = odds,
      error: () => { /* keep last odds on a transient fetch error */ },
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
